import { useTranslation } from 'react-i18next'
import {
  languageNames,
  supportedLanguages
} from '@lib/localisation/config'
import { OptionType } from '@/shared/api/BaseAPI.model'
import Select from '../Select/Select'
import styles from './LanguageSelect.module.scss'

interface LanguageSelectProps {
  label?: string
  /** Fits its content, for the corner of a card rather than a form row. */
  compact?: boolean
  /** Dark text and outline, for a light surface such as the 404 paper. */
  dark?: boolean
}

const options: OptionType[] = supportedLanguages.map(code => ({
  value: code,
  label: languageNames[code]
}))

function LanguageSelect({ label, compact, dark }: LanguageSelectProps) {
  const { i18n } = useTranslation()
  const value =
    options.find(option => option.value === i18n.resolvedLanguage) ?? null

  return (
    <div className={dark ? styles.dark : undefined}>
      <Select
        field={{ name: 'language' }}
        label={label}
        // A labelled picker keeps its label raised, like the form fields.
        focused={!!label}
        options={options}
        value={value}
        onChange={option => {
          if (
            option &&
            !Array.isArray(option) &&
            option.value !== i18n.resolvedLanguage
          ) {
            i18n.changeLanguage(option.value as string)
          }
        }}
        readonly
        hideClearIcon
        widthFitContent={compact}
        minWidth={compact ? '7.5rem' : undefined}
      />
    </div>
  )
}

export default LanguageSelect
